import * as yup from "yup";
import { ICreateBankTransfer } from "../../../../../interfaces-and-types";

// const internationalTrsfBeneficiarySchema = yup.object({
//   bank_name: yup.string().required('Bank name is required'),
//   account_name: yup.string().required('Account name is required'),
//   email: yup.string().email('Invalid email format').required('Email is required'),
//   phone_number: yup.string().required('Phone number is required'),
//   street_number: yup.string().required('Street number is required'),
//   street_name: yup.string().required('Street name is required'),
//   city: yup.string().required('City is required'),
//   postal_code: yup.string().required('Postal code is required')
// });

export const singleBankTransferSchema: yup.SchemaOf<ICreateBankTransfer> = yup
  .object({
    // actual transfer details
    reference: yup.string().required("Reference is required"),
    beneficiary_id: yup.string().nullable().optional(),
    country: yup.string().required("Country is required"),
    bank_code: yup
      .string()
      .required("Bank is required")
      .when("country", {
        is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
        then: yup.string().nullable().optional(),
      }),
    account_number: yup.string().required("Account number is required"),
    amount: yup
      .number()
      .transform((_value, originalValue) =>
        !originalValue ? 0 : Number(originalValue.toString().replace(/,/g, ""))
      )
      .required("Amount is required")
      .positive("Amount must be greater than zero"),
    currency: yup.string().required("Currency is required"),
    description: yup.string().nullable().optional().max(300),
    save_as_beneficiary: yup.boolean().nullable().optional(),
    wallet_account_tags: yup
      .array()
      .of(
        yup.object().shape({
          account_tag: yup.string().required("Account tag is required"),
          amount: yup
            .number()
            // .nullable()
            .typeError("Amount is required")
            .required("Amount to tag to wallet is required")
            .positive("Amount must be greater than zero")
            .min(0),
          description: yup.string().nullable().optional().max(300),
          metadata: yup
            .mixed()
            .nullable()
            .test("metadata-test", "Invalid metadata", (value) => {
              if (value === null) {
                return true;
              }
              if (typeof value !== "object") {
                return false;
              }
              // test if every key in metadata has a string or object value
              return Object.values(value).every(
                (v) =>
                  typeof v === "string" ||
                  typeof v === "number" ||
                  typeof v === "object"
              );
            }),
        })
      )
      .nullable()
      .optional(),

    // international_beneficiary: yup
    //   .object()
    //   .optional()
    //   .when("country", {
    //     is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
    //     then: yup
    //       .object({
    //         bank_name: yup.string().required("Bank name is required"),
    //         account_name: yup.string().required("Account name is required"),
    //         sort_code: yup
    //           .string()
    //           .max(6, "Sort code is a maximum of 6 numbers")
    //           .required("Postal code is required"),
    //         swift_code: yup.string().required("Postal code is required"),
    //         email: yup
    //           .string()
    //           .email("Invalid email format")
    //           .required("Email is required"),
    //         phone_number: yup.string().required("Phone number is required"),
    //         street_number: yup.string().required("Street number is required"),
    //         street_name: yup.string().required("Street name is required"),
    //         city: yup.string().required("City is required"),
    //         postal_code: yup.string().required("Postal code is required"),
    //       })
    //       .required("Please enter all details for the international transfer"),
    //   }),

    // intl beneficiary
    bank_name: yup
      .string()
      .optional()
      .when("country", {
        is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
        then: yup.string().required("Bank name is required"),
      }),
    account_name: yup.string().when("country", {
      is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
      then: yup.string().required("Beneficiary name is required"),
    }),
    sort_code: yup
      .string()
      // .max(6, "Sort code is a maximum of 6 numbers") // Routing/SortCode: Routing no can be more than 6 chars
      .when("country", {
        is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
        then: yup.string().required("Sort code is required"),
      }),
    swift_code: yup.string().when("country", {
      is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
      then: yup.string().required("Swift code is required"),
    }),
    email: yup
      .string()
      .email("Invalid email format")
      .when("country", {
        is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
        then: yup.string().required("Email is required"),
      }),
    phone_number: yup.string().when("country", {
      is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
      then: yup.string().required("Phone number is required"),
    }),
    street_number: yup.string().when("country", {
      is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
      then: yup.string().required("Street number is required"),
    }),
    street_name: yup.string().when("country", {
      is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
      then: yup.string().required("Street name is required"),
    }),
    city: yup.string().when("country", {
      is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
      then: yup.string().required("City is required"),
    }),
    postal_code: yup.string().when("country", {
      is: (ctry: string) => ctry && ctry.toUpperCase() !== "NG",
      then: yup.string().required("Postal code is required"),
    }),

    // helper properties for batch upload mode
    beneficiaryName: yup.string().nullable().optional(),
    beneficiaryEmail: yup.string().nullable().optional(),
    isBeneficiaryResolved: yup.boolean().required(),
    isLoadingResolveBeneficiary: yup.boolean().required(),
    isErrorResolveBeneficiary: yup.boolean().required(),

    // helpers for edit mode in batch list
    isEditModeHelper: yup.boolean().optional(),
    tempEditModeAmount: yup.number().optional(),

    // helpers to display details in  batch list after insertion in list
    accountNameHelper: yup.string().nullable().optional(),
    bankNameHelper: yup.string().nullable().optional(),
    fullNameHelper: yup.string().nullable().optional(),
    // sourceCurrencyDebitAmountHelper: yup.number().nullable().optional(),
  })
  .required();
